import { useTranslation } from 'react-i18next';

export const StaffOnlyResultsHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="e-reservation__header">
      <div
        className="e-reservation__th e-reservation__th--name"
        dangerouslySetInnerHTML={{ __html: t('staffOnly.header.nameEmail') }}
      />
      <div className="e-reservation__th">
        {t('staffOnly.header.reservationNo')}
      </div>
      <div className="e-reservation__th">{t('staffOnly.header.dateTime')}</div>
      <div className="e-reservation__th">{t('staffOnly.header.facility')}</div>
      <div
        className="e-reservation__th"
        dangerouslySetInnerHTML={{ __html: t('staffOnly.header.passCode') }}
      />
    </div>
  );
};
